import Form2NullableType from './nullabletype.jsx';
import Form2ReferencedDocumentSchema from './referencedDocumentSchema.jsx';
import Form2HsmStatementSchema from './hsmStatementSchema.jsx';
import Form2Array from './array.jsx';
import { getPropertyGrid2LeafElementType } from './elementTypesLeaves.js';

/**
 * Full PropertyGrid2 static tag map (nullable / referenced / array layered on leaves).
 */
export function getPropertyGrid2ElementType(element) {
    if ('format' in element) {
        switch (element.format) {
            case 'nullableType':
                return Form2NullableType;
            case 'ReferencedDocumentSchema':
                return Form2ReferencedDocumentSchema;
            case 'HSMStatement_Schema':
                return Form2HsmStatementSchema;
            default:
                break;
        }
    }

    if (element.type === 'array') return Form2Array;

    return getPropertyGrid2LeafElementType(element);
}
